import React                from "react";
import Navigate             from "Dashboard/Core/Navigate";
import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";



/**
 * Returns the Activity ID
 * @returns {Number}
 */
function useActivityID() {
    const { activityID } = Navigate.useParams();
    const { credential } = Store.useState("auth");
    return activityID || credential.activityID || 0;
}

/**
 * Goes to an Activity Url
 * @returns {Function}
 */
function useActivityGoto() {
    const { activityID } = Navigate.useParams();
    const navigate = Navigate.useGoto();

    return (...args) => {
        if (args.length === 1 && args[0].startsWith("/")) {
            navigate(...args);
        } else if (activityID) {
            navigate("ACTIVITIES", activityID, ...args);
        } else {
            navigate("ACTIVITY", ...args);
        }
    };
}

/**
 * Creates an Url for the given title
 * @param {String} title
 * @param {String} parent
 * @returns {String}
 */
function useUrl(title, parent) {
    return React.useMemo(() => {
        if (!title) {
            return "";
        }

        const slug = Utils.createSlug(title);
        return `${process.env.REACT_APP_WEB}${parent}/${slug}`;
    }, [ title, parent ]);
}



/**
 * Returns the Error Count in the Step
 * @param {Object} fields
 * @param {Object} errors
 * @param {String} step
 * @returns {Number}
 */
function getErrorCount(fields, errors, step) {
    let result = 0;
    if (!fields[step]) {
        return result;
    }

    for (const field of Object.keys(errors)) {
        if (!errors[field]) {
            continue;
        }
        if (fields[step].includes(field)) {
            result += 1;
            continue;
        }
        if (field.includes("-")) {
            const parts     = field.split("-");
            const fieldName = parts[0];
            if (fields[step].includes(fieldName)) {
                result += 1;
            }
        }
    }
    return result;
}




// The public API
export default {
    useActivityID,
    useActivityGoto,
    useUrl,

    getErrorCount,
};
